import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import BuyerLayout from '../components/BuyerLayout';

const RoleBasedLayout = () => {
    const { user, loading } = useAuth();

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!user) {
        return <Navigate to="/login" />;
    }

    if (user.role && user.role.toLowerCase() === 'buyer') {
        return <BuyerLayout />;
    }

    // Default to DashboardLayout for workers and brokers
    // DashboardLayout handles navItems internally or uses defaults
    return <DashboardLayout><Outlet /></DashboardLayout>;
};

export default RoleBasedLayout;
